import React from "react";
import { Form, Checkbox, Input, Radio, Row, Col } from "antd";

const Section3 = ({ formValues, setFormValues, onNext, loading }) => {
  // Service category lists
  const creativeProduction = [
    "Graphic Design",
    "Video Production/TV Commercials",
    "Audio Production",
    "Print Design",
    "Content Creation",
  ];

  const digitalMarketing = [
    "SEO (Search Engine Optimization)",
    "Local SEO & Google Business Profile Optimization",
    "PPC (Pay-per-click) Advertising",
    "Social Media Marketing (Management & Ads)",
    "Email Marketing",
    "Web Design & Development",
    "Website Hosting",
    "Website Maintenance",
    "Conversion Rate Optimization (CRO)",
    "Analytics",
    "Ecommerce Integration",
  ];

  const advertisingChannels = [
    "TV (Broadcast/Streaming)",
    "Radio",
    "Print (Newspapers, Magazines, Flyers)",
    "Billboards / Outdoor Advertising",
    "Digital Billboards/Posters",
    "Programmatic Advertising",
    "Direct Mail",
    "Geofencing",
  ];

  const publicEngagement = [
    "Public Relations",
    "Brand Management",
    "Event Marketing",
    "Event Management",
    "CRM / Lead Management",
    "Surveys",
    "Restaurant Placemat Advertising",
    "Influencer Marketing",
    "Webforms",
    "Other (please specify)",
  ];

  const renderCheckboxGrid = (options, selected, keyName) => {
  const items = [...options].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  // 2) split into two columns (fill top-to-bottom)
  const half = Math.ceil(items.length / 2);
  const left = items.slice(0, half);
  const right = items.slice(half);

  return (
    <Checkbox.Group
      value={selected || []}
      onChange={(vals) => setFormValues({ ...formValues, [keyName]: vals })}
      style={{ width: "100%" }}
    >
      <Row gutter={[24, 8]}>
        <Col xs={24} md={12}>
          {left.map((label) => (
            <div key={label} style={{ marginBottom: 8 }}>
              <Checkbox value={label}>{label}</Checkbox>
            </div>
          ))}
        </Col>
        <Col xs={24} md={12}>
          {right.map((label) => (
            <div key={label} style={{ marginBottom: 8 }}>
              <Checkbox value={label}>{label}</Checkbox>
            </div>
          ))}
        </Col>
      </Row>
    </Checkbox.Group>
  );
};


  // const handleNextClick = () => {
  //   if (!formValues.area || formValues.area.length === 0) {
  //     return alert("Please select at least one county.");
  //   }
  //   if (!formValues.localWorkPercent) {
  //     return alert("Please select your local work percentage.");
  //   }
  //   onNext();
  // };

  return (
    <Form layout="vertical">

      <p style={{ marginBottom: "15px", fontStyle: "italic" }}>
        Select only those services you <strong>actively deliver</strong> to clients —
        not ones you’re exploring or subcontracting.
      </p>

      {/* Creative & Production */}
      <Form.Item label="12. Creative & Production">
        {renderCheckboxGrid(creativeProduction, formValues.creativeProduction, "creativeProduction")}
      </Form.Item>

      {/* Digital Marketing */}
      <Form.Item label="13. Digital Marketing">
        {renderCheckboxGrid(digitalMarketing, formValues.digitalMarketing, "digitalMarketing")}
      </Form.Item>

      {/* Advertising Channels & Media Buys */}
      <Form.Item label="14. Advertising Channels & Media Buys">
        {renderCheckboxGrid(advertisingChannels, formValues.advertisingChannels, "advertisingChannels")}
      </Form.Item>

      {/* Public Engagement & Strategy */}
      <Form.Item label="15. Public Engagement & Strategy">
        {renderCheckboxGrid(publicEngagement, formValues.publicEngagement, "publicEngagement")}
      </Form.Item>

      {/* Other (if selected in Public Engagement) */}
      {formValues.publicEngagement?.includes("Other (please specify)") && (
        <Form.Item style={{ marginTop: "10px" }} label="Please specify other services">
          <Input
            placeholder="List any other services your agency delivers"
            value={formValues.otherServices || ""}
            onChange={(e) =>
              setFormValues({ ...formValues, otherServices: e.target.value })
            }
          />
        </Form.Item>
      )}

      {/* Creative Development Question */}
      <Form.Item label="16. Do you offer creative development (e.g., copywriting, design) for clients with limited marketing assets?">
        <Radio.Group
          value={formValues.creativeDevelopment}
          onChange={(e) =>
            setFormValues({ ...formValues, creativeDevelopment: e.target.value })
          }
        >
          <Radio value="Yes - we create copy & design assets in-house">
            Yes - we create copy & design assets in-house
          </Radio>
          <Radio value="No - we only work with client-provided assets">
            No - we only work with client-provided assets
          </Radio>
          <Radio value="Depends">Depends (please explain)</Radio>
        </Radio.Group>
      </Form.Item>

      {/* If Depends → explanation field */}
      {formValues.creativeDevelopment === "Depends" && (
        <Form.Item label="Please explain your approach">
          <Input.TextArea
            placeholder="Explain what depends on the situation (e.g., project size, budget)"
            rows={3}
            value={formValues.creativeDevelopmentExplanation || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                creativeDevelopmentExplanation: e.target.value,
              })
            }
          />
        </Form.Item>
      )}
    </Form>
  );
};

export default Section3;
